import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import SafariPinnedTab from '@images/favicon/safari-pinned-tab.svg';

const SeoHead = ({ title, description, image, metadata, location }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            defaultTitle: title
            defaultDescription: description
            siteUrl
            twitterUsername
            defaultImage: image
          }
        }
      }
    `,
  );

  const {
    defaultTitle,
    defaultDescription,
    siteUrl,
    twitterUsername,
    defaultImage,
  } = metadata || site.siteMetadata;

  const pathname = location || '/';
  const imagePath = image || defaultImage;
  const seoImage =
    imagePath && imagePath.startsWith('http') ? imagePath : `${siteUrl}${imagePath || ''}`;

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: seoImage,
    url: `${siteUrl}${pathname}`,
  };

  const headTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;

  return (
    <>
      <html lang="en" />
      <title>{headTitle}</title>

      <link rel="mask-icon" href={SafariPinnedTab} color="#ff7171" />
      <meta name="msapplication-TileColor" content="#f6f6f6" />

      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />

      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterUsername} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
    </>
  );
};

export default SeoHead;

SeoHead.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  metadata: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    siteUrl: PropTypes.string,
    twitterUsername: PropTypes.string,
    image: PropTypes.string,
  }),
  location: PropTypes.string,
};

SeoHead.defaultProps = {
  title: null,
  description: null,
  image: null,
  metadata: null,
  location: '/',
};
